// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-1478216a] {\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n}\n[dir=ltr] .margin[data-v-1478216a] {\n  margin-right: 40px;\n}\n[dir=rtl] .margin[data-v-1478216a] {\n  margin-left: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
